import { render, staticRenderFns } from "./select-mapping-field.vue?vue&type=template&id=3cf5a046"
import script from "./select-mapping-field.vue?vue&type=script&lang=ts"
export * from "./select-mapping-field.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports